import { render, staticRenderFns } from "./Anywhere_stretches.vue?vue&type=template&id=56381f94&"
import script from "./Anywhere_stretches.vue?vue&type=script&lang=js&"
export * from "./Anywhere_stretches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports